import { API_FILE_TYPE } from '../../constants';
import AttachmentFieldLayout from './AttachmentFieldLayout';
import { useUiTheme } from 'framework/uiTheme';
import withLightbox from '../../lightbox/withLightbox';
import { Box } from '@mui/material';
import { artifactsFilesListSx, artifactsPhotosListSx } from './artifactsLayoutSx';

type AttachmentsListLayoutProsp = {
  attachments?: { id: string; title: string; type: string }[];
  label?: Nullable<string>;
  openLightbox: (
    images: any[],
    index: number,
    func: (id: number | string, title: string) => void,
    isDownload: boolean,
  ) => void;
  downloadFile: (id: number | string, fileName?: string) => void;
  getThumbnail: (id: number | string, size: string) => Promise<Nullable<string>> | Nullable<string> | void;
  openPreview: (id: number | string) => void;
  isDownloadAvailable?: boolean;
  isPhotos?: boolean;
};

const AttachmentsListLayout = ({
  attachments = [],
  label = null,
  openLightbox,
  downloadFile,
  getThumbnail,
  openPreview,
  isDownloadAvailable = true,
  isPhotos = false,
}: AttachmentsListLayoutProsp) => {
  const { BaseFieldLayout } = useUiTheme();

  const images = attachments && attachments.filter(file => file.type === API_FILE_TYPE.image.alias);

  const files = attachments && attachments.filter(file => file.type !== API_FILE_TYPE.image.alias);

  const isPhotosLabel = isPhotos || label === 'Photos';

  return (
    <BaseFieldLayout
      isColumnDirection={!!attachments.length}
      label={label}
      value={
        attachments &&
        !!attachments.length && (
          <>
            <Box
              component="ul"
              className={isPhotosLabel ? 'files-list__photos' : 'files-list__files'}
              sx={isPhotosLabel ? artifactsPhotosListSx : artifactsFilesListSx}
            >
              {!!images?.length &&
                images.map(img => (
                  <Box component="li" key={img.id}>
                    <AttachmentFieldLayout
                      value={img}
                      getThumbnail={getThumbnail}
                      handleDownload={() => downloadFile(img.id, img.title)}
                      handleClick={() =>
                        openLightbox(
                          images,
                          images.indexOf(img),
                          (id, title) => downloadFile(id || img.id, title || img.title),
                          isDownloadAvailable,
                        )
                      }
                    />
                  </Box>
                ))}
              {!!files?.length &&
                files.map(
                  file =>
                    file && (
                      <Box component="li" key={file.id}>
                        <AttachmentFieldLayout
                          value={file}
                          handleClick={() => downloadFile(file.id, file.title)}
                          handleOpenPreview={() => openPreview(file.id)}
                          isDownloadAvailable={isDownloadAvailable}
                        />
                      </Box>
                    ),
                )}
            </Box>
          </>
        )
      }
    />
  );
};

export default withLightbox(AttachmentsListLayout);
